import React from 'react';
import PropTypes from 'prop-types';

const SelectedPlanInfoCard = ({
  planName,
  devices,
  alerts,
  reports,
  dataHistoryValue,
  dataHistoryUnit,
  userRoles,
  alertingExtras,
  samlLogin,
  onComparePlans,
}) => {
  const formatValue = (value) => {
    if (typeof value === 'number' && value >= 1000000) {
      return 'unlimited';
    }
    return value;
  };

  const formatBooleanValue = (value) => (value ? 'yes' : 'no');

  const formatDataHistory = (value, unit) => {
    const plural = value !== 1 ? 's' : '';
    return `${value} ${unit}${plural}`;
  };

  return (
    <div className="card">
      <div className="card-body">
        <div className="mb-4">
          <span className="badge bg-success" style={{ padding: '10px 16px', fontSize: '14px', color: 'white' }}>
            {planName}
          </span>
        </div>

        <div className="mb-3">
          <div className="d-flex justify-content-between py-1">
            <span>Devices</span>
            <span className="font-weight-bold">{formatValue(devices)}</span>
          </div>
          <div className="d-flex justify-content-between py-1">
            <span>Users</span>
            <span className="font-weight-bold">unlimited</span>
          </div>
          <div className="d-flex justify-content-between py-1">
            <span>Alerts</span>
            <span className="font-weight-bold">{formatValue(alerts)}</span>
          </div>
          <div className="d-flex justify-content-between py-1">
            <span>Reports</span>
            <span className="font-weight-bold">{formatValue(reports)}</span>
          </div>
          <div className="d-flex justify-content-between py-1">
            <span>Data History</span>
            <span className="font-weight-bold">{formatDataHistory(dataHistoryValue, dataHistoryUnit)}</span>
          </div>
          <div className="d-flex justify-content-between py-1">
            <span>User Roles</span>
            <span className="font-weight-bold">{formatBooleanValue(userRoles)}</span>
          </div>
          <div className="d-flex justify-content-between py-1">
            <span>Alerting Extras</span>
            <span className="font-weight-bold">{formatBooleanValue(alertingExtras)}</span>
          </div>
          <div className="d-flex justify-content-between py-1">
            <span>SAML Login</span>
            <span className="font-weight-bold">{formatBooleanValue(samlLogin)}</span>
          </div>
        </div>

        <div>
          <button type="button" onClick={onComparePlans} className="btn btn-link p-0" style={{ textDecoration: 'underline', justifyContent: 'flex-start' }}>
            compare plans
          </button>
        </div>
      </div>
    </div>
  );
};

SelectedPlanInfoCard.propTypes = {
  planName: PropTypes.string.isRequired,
  devices: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  alerts: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  reports: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  dataHistoryValue: PropTypes.number.isRequired,
  dataHistoryUnit: PropTypes.oneOf(['day', 'year', 'month']).isRequired,
  userRoles: PropTypes.bool.isRequired,
  alertingExtras: PropTypes.bool.isRequired,
  samlLogin: PropTypes.bool.isRequired,
  onComparePlans: PropTypes.func.isRequired,
};

export default SelectedPlanInfoCard;
